import React from "react";

function SimpleDropdown({
  label,
  options = [],
  value,
  onChange,
  isAlert = false,
  placeholder,
  disabled = false,
  minWidth = 120,
  style = {},
}) {
  return (
    <div style={{ display: "flex", alignItems: "center", gap: 8, ...style }}>
      {label && (
        <span style={{ fontSize: 11, fontWeight: 600, color: "#64748b", whiteSpace: "nowrap" }}>
          {label}
        </span>
      )}
      <div style={{ position: "relative" }}>
        <select
          value={value ?? ""}
          onChange={e => onChange(e.target.value)}
          disabled={disabled}
          style={{
            padding: "6px 28px 6px 10px",
            borderRadius: 8,
            border: `1.5px solid ${isAlert ? "#f59e0b" : "#e2e8f0"}`,
            background: isAlert ? "#fffbeb" : "#fff",
            fontSize: 12,
            fontWeight: 600,
            color: isAlert ? "#b45309" : "#1e293b",
            cursor: disabled ? "not-allowed" : "pointer",
            outline: "none",
            appearance: "none",
            WebkitAppearance: "none",
            minWidth: minWidth,
            boxShadow: "0 1px 3px rgba(0,0,0,0.06)",
            opacity: disabled ? 0.7 : 1,
          }}
        >
          {placeholder && <option value="">{placeholder}</option>}
          {options.map((opt, index) => {
            const val = typeof opt === "object" ? opt.value : opt;
            const lbl = typeof opt === "object" ? opt.label : opt;
            return (
              <option key={index} value={val}>
                {lbl}
              </option>
            );
          })}
        </select>
        <span style={{
          position: "absolute",
          right: 8,
          top: "50%",
          transform: "translateY(-50%)",
          fontSize: 9,
          color: isAlert ? "#b45309" : "#94a3b8",
          pointerEvents: "none",
        }}>▾</span>
      </div>
    </div>
  );
}

export default SimpleDropdown;
